import React, { useState, useEffect } from 'react';
import { api } from '../apiClient';

const SchedulerStatusPage = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/scheduler-status');
      setStatus(response.data);
    } catch (err) {
      setError('Failed to fetch scheduler status. You might not have the required permissions.');
      console.error(err);
    }
    setLoading(false);
  };

  const triggerScheduler = async () => {
    setLoading(true);
    setError(null);
    try {
      await api.post('/trigger-scheduler');
      // After triggering, wait a bit and then refresh the status
      setTimeout(() => {
        fetchStatus();
      }, 1000);
    } catch (err) {
      setError('Failed to trigger scheduler. You might not have the required permissions.');
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Scheduler Status</h1>
      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {status && (
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="font-semibold">Last Run Time:</p>
              <p>{status.last_run_time ? new Date(status.last_run_time).toLocaleString() : 'N/A'}</p>
            </div>
            <div>
              <p className="font-semibold">Next Run Time:</p>
              <p>{status.next_run_time ? new Date(status.next_run_time).toLocaleString() : 'N/A'}</p>
            </div>
            <div>
              <p className="font-semibold">Currently Processing:</p>
              <p>{status.currently_processing.length > 0 ? status.currently_processing.join(', ') : 'None'}</p>
            </div>
          </div>
          <div className="mt-6 flex space-x-4">
            <button
              onClick={fetchStatus}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              disabled={loading}
            >
              Refresh Status
            </button>
            <button
              onClick={triggerScheduler}
              className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
              disabled={loading}
            >
              Trigger Scheduler Manually
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SchedulerStatusPage;
